export default {"src":"https://cdn.jetlend.ru/_next/static/media/agreement-feature.85e3c458.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};